<div class="security-panel-item">
  <img
    *ngIf="item?.image?.value"
    [src]="item.image.value?.src"
    [alt]="item.image.value?.alt"
    loading="lazy"
    [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}"
  />
  <p *ngIf="item?.header?.value" [innerHTML]="item.header.value"></p>
  <div class="security-panel-item__link">
    <app-bg-button
      *ngIf="item?.link?.value"
      [data]="item.link.value"
      [buttonColor]="item?.linkColor?.value"
    ></app-bg-button>
  </div>
</div>
